import Vue from 'vue'
import * as MutationTypes from '@/store/mutation-types'

export default {
	[MutationTypes.SET_POLLS]: (state, polls) => {
		Vue.set(state, 'polls', polls);
	},
	[MutationTypes.SET_UID]: (state, uid) => {
		Vue.set(state, 'uid', uid);
	},
	[MutationTypes.SET_CURRENT_POLL_ID]: (state, currentPollId) => {
		Vue.set(state, 'currentPollId', currentPollId);
	},
	[MutationTypes.SET_ERROR]: (state, error) => {
		Vue.set(state, 'error', error);
	},
}